import {initalizerTypes} from "../actions/initializer_actions"
import {jobTypes} from "../actions/_vacancies_actions";

const jobsReducerDefaultState = [];

export default (state = jobsReducerDefaultState, action) => {
    switch (action.type) {
        case initalizerTypes.FETCH_VACANCY_DATA:
            return [
                ...action.vacancies
            ];
        case jobTypes.CREATE_NEW:
            return [
                ...state,
                action.payload
            ];
        case jobTypes.EDIT_DATA:
            return state.map(vacante => {
                if (vacante.jobID === action.id){
                    return {
                        ...vacante,
                        ...action.updates
                    }
                } else {
                    return vacante
                }
            });
        case jobTypes.REMOVE_JOBS:
            return [...action.newValues]
        default:
            return state;
    }
}
